export const dateTimeFormats: Record<string, string> = {
  time: 'HH:mm',
};
